import { IRepasseDadosBIRequest } from "../../../Interfaces/Repasse/RepasseDadosBI/RepasseDadosBIInterface";
import { InserirDadosRepasseBI } from "../../../Services/Repasse/RepasseDadosBI/RepasseDadosBIServices";

import { Controller } from "../../Controller";

export async function InserirRepasseDadosBIController(
    requestBody: IRepasseDadosBIRequest
) {
    return Controller(InserirDadosRepasseBI(requestBody));
}
